import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import OfferCard from './OfferCard';
import { useOffers } from '../../hooks/directory/useOffers';
import { Loading, PostCardSkeleton, StackSkeleton } from '../layout/Skeletons';

/**
 * What a shop is offering, on its own listing. Its opening hours are in the
 * contact card, with the rest of the practical information.
 *
 * Takes the place of the appointment form on a listing that is a shopfront.
 */
function OffersPanel({ provider }) {
  const { offers, loading, reload } = useOffers({ provider: provider.slug });

  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Typography variant="h3" component="h3" sx={{ mb: 1.5 }}>
        Offres
      </Typography>

      {loading ? (
        <Loading label="Chargement des offres">
          <StackSkeleton count={1}>{PostCardSkeleton}</StackSkeleton>
        </Loading>
      ) : offers.length > 0 ? (
        <Stack spacing={2}>
          {offers.map((offer) => (
            <OfferCard
              key={offer.uuid}
              offer={offer}
              citySlug={provider.city?.slug}
              isOwn={Boolean(provider.is_own_listing)}
              onModerated={reload}
            />
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Aucune offre annoncée pour l’instant.
        </Typography>
      )}
    </Paper>
  );
}

export default OffersPanel;
